import { Injectable } from '@angular/core';
import { BehaviorSubject ,  Subject } from 'rxjs';
import { EquipmentFailureEffect } from '../../../../viewmodels/equipment/equipment-failure-effect';
import { RiskMatrixCell } from '../../../../viewmodels/admin/risk-matrices/risk-matrix-cell';
import { RiskMatrixSelection } from '../../../../viewmodels/runnable-model/risk-matrix-selection';

@Injectable({
  providedIn: 'root',
})
export class ConsequenceRiskMatrixService {
  failureEffect = new BehaviorSubject<EquipmentFailureEffect>(null);
  riskMatrixSelection = new BehaviorSubject<RiskMatrixSelection>(new RiskMatrixSelection());

  editingRiskMatrixSelection: Subject<any> = new Subject<any>();
  acceptedRiskMatrixSelection: Subject<any> = new Subject<any>();

  showDialog: Subject<any> = new Subject<any>();

  setItem(item: EquipmentFailureEffect) {
    this.failureEffect.next(item);

    const selection = new RiskMatrixSelection();

    selection.riskMatrixId = item.consequenceRiskMatrixId;
    selection.riskMatrixCell = item.selectedConsequenceRiskMatrixCell;

    this.riskMatrixSelection.next(selection);
  }

  constructor() {}

  selectRiskMatrix() {
    this.showDialog.next();
    this.editingRiskMatrixSelection.next();
  }

  acceptRiskMatrixSelection(acceptedRiskMatrixId: string, acceptedRiskMatrixCell: RiskMatrixCell) {
    const selection = new RiskMatrixSelection();

    selection.riskMatrixId = acceptedRiskMatrixId;
    selection.riskMatrixCell = acceptedRiskMatrixCell;

    this.riskMatrixSelection.next(selection);

    this.commitChanges();

    this.acceptedRiskMatrixSelection.next();
  }

  private commitChanges() {
    if (!this.failureEffect.value) {
      return;
    }

    this.failureEffect.value.consequenceRiskMatrixId = this.riskMatrixSelection.value.riskMatrixId;
    this.failureEffect.value.selectedConsequenceRiskMatrixCellId = this.riskMatrixSelection.value.riskMatrixCell.riskMatrixCellId;
    this.failureEffect.value.selectedConsequenceRiskMatrixCell = this.riskMatrixSelection.value.riskMatrixCell;
  }
}
